export enum ReservationEventType {
  RideRequestCreated = 'Ride Request Created',
  RideRequestCancelled = 'Ride Request Cancelled',
  RideRequestUpdated = 'Ride Request Updated',
  DriverSelected = 'Driver Selected',
  ReservationCancelled = 'Reservation Cancelled',
  FavoriteLocationSelected = 'Favorite Location Selected',
  DetailsClosed = 'Details Panel Closed'
}

export class ReservationEvent {
  eventType: ReservationEventType;
}
